import { render } from "./privacyProvider.vue?vue&type=template&id=50c8bda7"
import script from "./privacyProvider.vue?vue&type=script&lang=js"
export * from "./privacyProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__